import { FC } from 'react';
import { t } from 'i18next';
import { Box, Button, Typography } from '@mui/material';

import { CustomModal, StatusBanner } from '@components';
import { theme } from '@store';

interface SaveChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  discardChanges: () => void;
  handleSaveChanges: () => void;
  isValid: boolean;
  isLoading?: boolean;
}

export const SaveChangesModal: FC<SaveChangesModalProps> = ({
  isOpen,
  onClose,
  handleSaveChanges,
  discardChanges,
  isValid,
  isLoading,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('saveChangesModal.title')}
      isLoading={isLoading}
    >
      {!isValid && (
        <StatusBanner
          text={t('saveChangesModal.warningMessage')}
          variant='warning'
        />
      )}
      <Typography variant='body1' sx={{ mt: 2, mb: 3 }}>
        {t('saveChangesModal.message')}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Button
          size='large'
          color='error'
          onClick={discardChanges}
          disabled={isLoading}
        >
          {t('saveChangesModal.discardChanges')}
        </Button>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size='large'
            variant='outlined'
            onClick={onClose}
            disabled={isLoading}
          >
            {t('saveChangesModal.keepEditing')}
          </Button>
          <Button
            size='large'
            color='secondary'
            variant='contained'
            disabled={isLoading || !isValid}
            onClick={handleSaveChanges}
            loading={isLoading}
            sx={{ color: theme.palette.common.white }}
          >
            {t('saveChangesModal.save')}
          </Button>
        </Box>
      </Box>
    </CustomModal>
  );
};
